import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import ElmoButton from '../../components/NewReportBuilder/ElmoButton';
import { resetReportAction } from '../../actions/reportBuilder';

export interface ResetReportButtonProps {
  dispatch: Dispatch<any>;
  onClick?: () => void;
  className?: string;
}

class ResetReportButton extends React.Component<ResetReportButtonProps> {
  onResetClicked = () => {
    if (this.props.onClick) {
      this.props.onClick();
    }

    this.props.dispatch(resetReportAction());
  }

  render() {
    return (
      <ElmoButton
        className={this.props.className}
        onClick={this.onResetClicked}
        type="text"
        id="report-builder-btn-clear-all"
      >
        Clear All
      </ElmoButton>
    );
  }
}

export default connect(
)(ResetReportButton);
